import {submitAccessRequestInfohidro} from "@/api/prognozweb/email.api";

const state = {
  response: [],
}
const mutations = {
  setResponse(state, data) {
    state.accessRequestsInfohidro = data ? data : [];
  },  
}
const actions = {
  async submitAccessRequestInfohidro({commit}, payload ){
    try {
      const response = await submitAccessRequestInfohidro(payload);
      commit('setResponse', response.data);
    } catch(error) {
      commit('setResponse', undefined);
    }
  },  
}
const getters = {
  response: (state) => state.response,  
}
export default {
  state,
  mutations,
  actions,
  getters
}
